// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "+393883675371",
  numero_telefono: "tel:+390810431175",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',

  */

  urlWeb: 'https://beejobacademy.discentya.it/',
  urlMaterialeDidattico: 'https://beejobacademy.discentya.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://beejobacademy.discentya.it/assets/media/corso/',
  urlImageCorsoHD: 'https://beejobacademy.discentya.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://beejobacademy.discentya.it/assets/media/corso/video/',
  web_api_url_base: 'https://beejobacademy.discentya.it/api/',

  urlStampa: 'https://beejobacademy.discentya.it/stampe/',

  urlAttestati: 'https://beejobacademy.discentya.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://beejobacademy.discentya.it/pages/certificate/',
  urlImagePartners: 'https://beejobacademy.discentya.it/assets/media/partners/',
  urlImageMedia: 'http://beejobacademy.discentya.it/assets/media/',

};

